import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b919874")

_pushScopeId("data-v-4b919874")
const _hoisted_1 = { style: {"width":"24px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("- -")
const _hoisted_3 = { class: "f-md df-middle flex-2" }
const _hoisted_4 = { class: "mr-6 list-avatar" }
const _hoisted_5 = { class: "nickname" }
const _hoisted_6 = { class: "flex-1 t-center" }
const _hoisted_7 = { class: "flex-1 f-bold t-right" }
const _hoisted_8 = { class: "mr-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("pts")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("- -")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_Line = _resolveComponent("Line")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["df-between df-middle list f-md", {'participate': _ctx.participate}]
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.list.rankNum > 0 && _ctx.list.rankNum <= 20)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.list.rankNum), 1)
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_2
            ], 64))
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Pic, {
            src: _ctx.list.avatarPic,
            fallback: "/img/user/Avatar@2x.png",
            width: "32",
            height: "32",
            class: "avatar"
          }, null, 8, ["src"]),
          (_ctx.list.rankNum === 1)
            ? (_openBlock(), _createBlock(_component_Pic, {
                key: 0,
                src: "membership/crown",
                class: "crown",
                width: "16",
                height: "16"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.list.nickName), 1)
      ]),
      _createVNode("div", _hoisted_6, _toDisplayString(_ctx.list.profitRate || _ctx.list.profitRate === 0 ? `${_ctx.profitRate}%` : '- -'), 1),
      _createVNode("div", _hoisted_7, [
        (_ctx.list.rankNum > 0 && _ctx.list.rankNum <= 20)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.list.prize || '- -'), 1),
              _createVNode(_component_t, { path: "membership_13" }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_10
            ], 64))
      ])
    ], 2),
    _createVNode(_component_Line)
  ], 64))
})